export default "__VITE_ASSET__DHeqYZWu__"